import { Board } from "./Board";
import { GameVars } from "../GameVars";
import { ChallengeManager } from "../challenge/ChallengeManager";
import { BoardManagerAI } from "./BoardManagerAI";

export class PositionMarker extends Phaser.Image {

    public board: Board;
    public p: string;

    constructor(game: Phaser.Game, board: Board) {

        super(game, 0, 0, "texture_atlas_1", "marker.png");

        this.board = board;

        this.anchor.set(.5);

        this.inputEnabled = true;
        this.events.onInputDown.add(this.onDown, this);
    }

    private onDown(): void {
        
        if (GameVars.challenge) {
            ChallengeManager.movePlayerSelectedPiece(this.p);
            ChallengeManager.removeHintButton();
        } else if (GameVars.againstAI) {
            BoardManagerAI.movePlayerSelectedPiece(this.p);
        }   
    }
}
